import type { PropsWithChildren } from "react";

import { O } from "@scripts/fp-ts";
import { type Label, SearchInputRaw } from "@scripts/react/components/form/TextInput";
import { Grid, GridCol } from "@scripts/react/components/layout/Grid";

import { type KlassProp, klassProp } from "../util/classnames";

type IssuerSitesSearchInputProps<P> = {
  placeholder: O.Option<string>;
  search: O.Option<string>;
  label: Label<P>;
  setSearch: (s: O.Option<string>) => void;
  disabled?: boolean;
};

export const IssuerSitesSearchInputGrid = <P,>(props: PropsWithChildren<IssuerSitesSearchInputProps<P> & { klass?: KlassProp }>) =>
  <Grid attrs={O.some("grid-sx-1")} klass={klassProp("justify-content-between", "mb-md-15", props.klass)}>
    <GridCol cols={["c-md-10", "c-lg-8"]} klass={klassProp("mb-1", "mb-md-0")}>
      <SearchInputRaw
        onChange={e => props.setSearch(O.fromPredicate((_: string) => _.length > 0)(e.target.value))}
        placeholder={props.placeholder}
        errorComponent={O.none}
        label={props.label}
        value={props.search}
        disabled={props.disabled}
      />
    </GridCol>
    {props.children}
  </Grid>;
